import React from 'react';
import { useParams } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import PersistentIframeController from 'src/components/common/persistentIframeRenderer/PersistentIframeController';
import { IframeApps } from 'src/components/common/persistentIframeRenderer/constants';
import Navbar from 'src/components/navbar/Navbar';
import { useTranslation } from 'react-i18next';
import { getAgentBaseRoute } from './routes';

const AddressTaskDetails = () => {
  const { t } = useTranslation();
  const { jobId } = useParams<{ jobId: string }>();
  const route = `${getAgentBaseRoute()}/${jobId}`;
  return  <>
    <Navbar  
    pageTitle={t('Address Resolution Agent')}
    />
    <DocumentTitle title={t('Address Resolution Agent')} />
    <PersistentIframeController
      route={route}
      appName={IframeApps.SHIPSY_AGENT}
    />
  </>
};

export default AddressTaskDetails;